<script setup lang="ts">
import { ReviewList } from '@/features/reviews';
import { useQuery } from '@urql/vue';
import { graphql } from '@/gql';

const props = defineProps<{
  companyId: number;
}>();

const { data: queryData } = useQuery({
  query: graphql(/* GraphQL */ `
    query CompanyReviewsTab_CompanyQuery($id: Int!) {
      company(id: $id) {
        id
        reviews {
          id
        }
      }
    }
  `),
});
</script>

<template>
  <ReviewList
    v-if="(reviews?.length ?? 0) !== 0"
    :reviews="reviews"
    :is-loading="isLoadingReviews"
    @fetch-next="fetchNextReviews"
  />
  <div v-else class="stub">У компании пока нет ни одного отзыва</div>
</template>
